import * as React from "react"
import { SourceControlProvider } from "@modules/graphql/types"
import {
  GitHubIcon,
  GitLabIcon,
  BitbucketIcon,
  IconProps,
  GoogleIcon,
} from "gatsby-interface"

const iconComponents: Record<SourceControlProvider, React.ComponentType> = {
  [SourceControlProvider.Github]: GitHubIcon,
  [SourceControlProvider.GithubEnterprise]: GitHubIcon,
  [SourceControlProvider.GitlabSelfManaged]: GitLabIcon,
  [SourceControlProvider.Gitlab]: GitLabIcon,
  [SourceControlProvider.Bitbucket]: BitbucketIcon,
  [SourceControlProvider.Google]: GoogleIcon,
  [SourceControlProvider.Workos]: function() {
    return <span>WorkOS</span>
  },
}

export type SourceControlProviderIconProps = IconProps & {
  sourceControlProvider: SourceControlProvider
}

export function SourceControlProviderIcon({
  sourceControlProvider,
  ...rest
}: SourceControlProviderIconProps) {
  const IconComponent = iconComponents?.[sourceControlProvider]

  return IconComponent ? <IconComponent {...rest} /> : null
}
